import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { ICorporateRegionAutocomplete } from 'corporate/types';

export const getRegionsAutocomplete = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ICorporateRegionAutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/regions/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<ICorporateRegionAutocomplete>(
    data.corporate_regions,
    data.total_count
  );
};
